/**
 * This is a presentation file.  Place all
 * code which calls, modifies or data in
 * a corresponding JSX Container File.
 */
import React from 'react';
import PropTypes from 'prop-types';

const submitFallBack = (e) => {
  e.preventDefault();
  return false;
};

const AdvForm = ({
  autocomplete,
  children,
  className,
  onChange,
  onSubmit,
}) => {
  const submitBehaviour = onSubmit || submitFallBack;

  return (
    <form
      autoComplete={autocomplete}
      className={`adv-form${className ? ` ${className}` : ''}`}
      onChange={onChange}
      onSubmit={submitBehaviour}
    >
      {children}
    </form>
  );
};

AdvForm.defaultProps = {
  autocomplete: '',
  className: '',
  onChange: () => {},
  onSubmit: null, // TODO set to empty func after removing default props from build
};

AdvForm.propTypes = {
  autocomplete: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default AdvForm;
